import React from "react";
import ValidatedTextInput from "../ValidatedTextInput/ValidatedTextInput.jsx";
import "./styles.scss";
import { Modal } from "react-bootstrap";
import PropTypes from "prop-types";

const DismissableModal = ({
  modalHeading,
  modalSubheading,
  modalHeader,
  modalBody,
  modalFooter,
  handleClose,
  className,
  modalWidth,
  show,
}) => {
  return (
    <Modal
      className="ps-dismissable-modal"
      show={show}
      style={{ width: modalWidth ? modalWidth : "" }}
      onHide={() => {
        handleClose(false);
      }}
      animation={false}
      dialogClassName={className ? className : ""}
      centered
      keyboard
    >
      <div
        className="ps-dismissable-modal__cancel-icon-container"
        onClick={() => {
          handleClose(false);
        }}
      >
        <img
          className="ps-dismissable-modal__cancel-icon"
          src="/images/icons/black-x-mark.svg"
        />
      </div>
      {modalHeading !== undefined && (
        <div>
          <div className="ps-dismissable-modal__title-container">
            <h3 className="ps-dismissable-modal__title">{modalHeading}</h3>
            {modalSubheading && (
              <p className="ps-dismissable-modal__title-subtext">
                {modalSubheading}
              </p>
            )}
          </div>
        </div>
      )}
      {modalHeading !== undefined && (
        <hr className="ps-divider--secondary ps-divider--full-width ps-dismissable-modal__hr" />
      )}
      <div>
        <div className={"ps-dismissable-modal__body"}>{modalBody}</div>
      </div>
      <div className={"ps-dismissable-modal__footer"}>{modalFooter}</div>
    </Modal>
  );
};

DismissableModal.propTypes = {
  modalHeading: PropTypes.string,
  modalSubheader: PropTypes.string,
  modalHeader: PropTypes.object,
  handleClose: PropTypes.func,
  show: PropTypes.bool,
};

export default DismissableModal;
